/**
 * Generated by orval v6.10.1 🍺
 * Do not edit manually.
 * API Reference
 * OpenAPI spec version: 1.0
 */

export type NameCheckResultGender = typeof NameCheckResultGender[keyof typeof NameCheckResultGender];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const NameCheckResultGender = {
  M: 'M',
  F: 'F',
} as const;
